import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ModSessionState {
  modSession: null | number;
}

const initialState: ModSessionState = {
  modSession: null,
};

const modSessionSlice = createSlice({
  name: "modSession",
  initialState,
  reducers: {
    setModDemoSession: (state, action: PayloadAction<number>) => {
      state.modSession = action.payload;
    },
    clearModSession: (state) => {
      state.modSession = null;
    },
  },
});

export const { setModDemoSession, clearModSession } = modSessionSlice.actions;
export default modSessionSlice.reducer;
